

























































import path from 'path';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { RouteConfig } from 'vue-router';
import { isExternal } from '@tencent/s2-client-vue-lib';
import SidebarItemLink from './SidebarItemLink.vue';
import { systemModule } from '@/store/modules/ModuleSystem';
import { appModule } from '@/store/modules/ModuleApp';

@Component({
	// Set 'name' here to prevent uglifyjs from causing recursive component not work
	// See https://medium.com/haiiro-io/element-component-name-with-vue-class-component-f3b435656561 for detail
	name: 'SidebarItem',
	components: {
		SidebarItemLink
	}
})
/** docs */
export default class extends Vue {
	@Prop({ required: true }) private item!: RouteConfig;
	@Prop({ default: false }) private isCollapse!: boolean;
	@Prop({ default: true }) private isFirstLevel!: boolean;
	@Prop({ default: false }) private isSubItem!: boolean;
	@Prop({ default: '' }) private basePath!: string;

	/** 待办列表 */
	public get todoList(): any {
		return systemModule.todoList;
	}

	/** document hooks */
	public get alwaysShowRootMenu(): any {
		if (this.item.meta && this.item.meta.alwaysShow) {
			return true;
		}

		return false;
	}

	/** document hooks */
	public get showingChildNumber(): any {
		if (this.item.children) {
			const showingChildren: any = this.item.children.filter((item: any): any => {
				if (item.meta && item.meta.hidden) {
					return false;
				}

				return true;
			});

			return showingChildren.length;
		}

		return 0;
	}

	/** document hooks */
	public get theOnlyOneChild(): any {
		if (this.showingChildNumber > 1) {
			return null;
		}

		if (this.item.children) {
			for (const child of this.item.children) {
				if (!child.meta || !child.meta.hidden) {
					return child;
				}
			}
		}

		// If there is no children, return itself with path removed,
		// because this.basePath already conatins item's path information
		return { ...this.item, path: '' };
	}

	/** document hooks */
	private resolvePath(routePath: string): any {
		if (isExternal(routePath)) {
			return routePath;
		}

		if (isExternal(this.basePath)) {
			return this.basePath;
		}

		let pathUrl: string = path.resolve(this.basePath, routePath);
		// console.log('pathUrl..', pathUrl);
		if (pathUrl === appModule.ENTRANCE_PAGE_PATH) {
			pathUrl = appModule.SECOND_PAGE_PATH;
		}

		return path.resolve(pathUrl);
	}
}
